import { MapPin } from "lucide-react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { site } from "../data/site";

export default function LocationsPage() {
  return (
    <>
      <SEO
        title="Service Areas | Polishing Singapore"
        description="Polishing Singapore serves residential, office, hotel, retail, restaurant and industrial surfaces across Singapore."
        canonical={`${site.domain}/locations`}
      />
      <PageHero title="Service Areas in Singapore" description="Surface polishing, repair, restoration and cleaning pages prepared for islandwide Singapore search intent." image="/assets/polishing/hero_machine.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {site.serviceAreas.map((area) => (
            <div key={area} className="surface-card p-6">
              <MapPin className="text-primary-700" />
              <h2 className="mt-4 font-heading text-2xl font-bold">{area}</h2>
              <p className="mt-3 text-sm leading-7 text-foreground-700">Suitable for stone, tile, parquet and concrete surface assessment requests.</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
